import { ProductBase } from "@made-people/grease-product";

export const getProductDiscontinuedStatus = (
  productBase: ProductBase,
): boolean => {
  const productDiscontinuedBool = productBase.attributes.find(
    (x) => x.attributeKey === "discontinued_bool",
  )?.value;

  return (
    productDiscontinuedBool === "1" ||
    productDiscontinuedBool === "true" ||
    productDiscontinuedBool === true ||
    productBase.discontinued
  );
};
